export const TIMESHEETS_LIST_RELOADING = 'TIMESHEETS_LIST_RELOADING'
export const TIMESHEETS_LIST_UPDATE = 'TIMESHEETS_LIST_UPDATE'
export const TIMESHEETS_LIST_CLEAN = 'TIMESHEETS_LIST_CLEAN'
export const TIMESHEET_PROP_UPDATE = 'TIMESHEET_PROP_UPDATE'
export const TIMESHEET_PROP_CLEAN = 'TIMESHEET_PROP_CLEAN'
export const TIMESHEET_SET_TIMER_STATE = 'TIMESHEET_SET_TIMER_STATE'
